import { render } from "./IconTournamentTime.vue?vue&type=template&id=71f2598c&ts=true"
import script from "./IconTournamentTime.vue?vue&type=script&lang=ts"
export * from "./IconTournamentTime.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__